'use client';

import { useControlledState } from 'codekit';

import styles from './styles.module.css';

interface MobileMenuTriggerProps {
	isActive: boolean;
	onActiveChange?: (active: boolean) => void;
}

function MobileMenuTrigger(props: MobileMenuTriggerProps) {
	// States
	const [isActive, setIsActive] = useControlledState(props.isActive, false);

	return (
		<div className={styles.container}>
			<label className={styles.label}>
				<input
					type="checkbox"
					className={styles.input}
					checked={!!isActive}
					onChange={(e) => {
						props.onActiveChange?.(e.target.checked);
						setIsActive(e.target.checked);
					}}
				/>
				<span className={styles.span} />
				<span className={styles.span} />
				<span className={styles.span} />
			</label>
		</div>
	);
}

export default MobileMenuTrigger;
